export default __webpack_public_path__ + "static/media/history.0eb1f5dd.svg";